import { Text } from "@meditect/medibase-components";

export const SalesCannotSaleArchivedStockItemError = () => {
  return (
    <Text>
      Certaines lignes de stock présentes dans la vente ont déjà été archivées. Veuillez recharger les produits dans le
      panier.
    </Text>
  );
};
